export default "__VITE_ASSET__D$su3Uc$__"